/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Is_CompanyInputs */

const en_case_field_is_company = /** @type {(inputs: Case_Field_Is_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company vehicle?`)
};

const pt_br2_case_field_is_company = /** @type {(inputs: Case_Field_Is_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veículo de empresa?`)
};

/**
* | output |
* | --- |
* | "Company vehicle?" |
*
* @param {Case_Field_Is_CompanyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_is_company = /** @type {((inputs?: Case_Field_Is_CompanyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Is_CompanyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_is_company(inputs)
	return pt_br2_case_field_is_company(inputs)
});